/*
Poornima 09/19/2022 2700799562 Fixed GAL-127,132,73,60,104 bugs
sohel 10/01/2022 2700799562 Global Field ->Download Configuration-> handle Error Toast Msg and Catagory Payload Changes.
saikrishna 10/03/2022 2700799562 Global Field Bugs _350,347,349
ashraf 10/04/2022 2700799562 fixed copy, page break issue
ashraf 10/06/2022 2700799562 fixed global field usage url
ashraf 10/07/2022 2700799562 fixed global field, field group bug fixes
Saikrishna  11/29/2022  2700799562 Filter type api integrated
Sohel  12/01/2022  2700799562 Download Configuration Api changes
Sohel 12/02/2022 3031450488 Global Field List Changes
Sai Maheshwar 12/02/2022 2700912712 mapped new repository fields data.
Rajesh 12/09/2022 2700799562 reset issue download
akhila 12/21/2022 2700912712 integrated lookup api for returnType
Ashraf 01/11/2022 2700799562 added actions to handle default audit data
Ashraf 01/12/2022 2700799562 conditional message render for audit list
Akhila 02/22/2023 3031450488 Added preview file functionlity in download configuration
Akhila 03/01/2023 3031450488 Added loader and download toast message for preview File
Dilip 04/29/2023 2701335619 changed integrated field type drop down api
Ravi 06/22/2023 2700799562 fixed submit issue
*/

import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../util/Rest';
import {GLOBAL_FIELD} from '../../../constants/MicroServiceConstants';
import {RETURN_TYPE, CATEGORY} from '../../../constants/Lookup';
import {fetchDownloadSuccess} from '../PreviewFileData';
import {submissionEnd} from '../CommonActions/commonActions';
const initialData = {
  baseCategoryData: [],
  fieldListData: {},
  fieldListDataUsage: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  fieldListStatus: null,
  groupData: {},
  joinFieldCodeData: [],
  fieldListPostStatus: null,
  userMetrix: '',
  addSuccessMsg: null,
  addGlobalFieldListData: {},
  addGlobalFieldListStatus: null,
  GlobalFieldListPrintStatus: null,
  fieldListUsageStatus: null,
  isSystemNoteLoading: false,
  systemNotesStatus: null,
  notesuccessMsg: null,
  allCodeAndDescription: [],
  globalFieldListData: {},
  linkedCategoriesData: [],
  dropDownData: {},
  defaultCode: null,
  defaultMessage: null,
  configurationUrl: '',
  dockey: '',
};
const slice = createSlice({
  name: 'addFieldList',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
      state.fieldListStatus = null;
    },
    fetchNoteStart: (state) => {
      state.isSystemNoteLoading = true;
      state.errorMsg = null;
    },
    postGroupData: (state, action) => {
      state.groupData = action.payload.response;
      state.fieldListStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    postSystemNotesData: (state, action) => {
      state.systemNotesStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.notesuccessMsg = action.payload.response;
      state.isSystemNoteLoading = false;
    },
    postGlobalFieldAddData: (state, action) => {
      state.addGlobalFieldListStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.addGlobalFieldListData = action.payload.response.placeResponse;
      state.addSuccessMsg = action.payload.message;
      state.userMetrix = action.payload.response.userMetrix;
    },
    getLinkedCategoriesData: (state, action) => {
      state.linkedCategoriesData = action.payload[0]?.destinationCategory;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getBaseCategoryData: (state, action) => {
      state.baseCategoryData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
      state.fieldListStatus = null;
    },
    getGlobalFieldListData: (state, action) => {
      state.globalFieldListData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getFieldTypeData: (state, action) => {
      state.fieldTypeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      // state.successMsg = action.payload?.response;
      // state.fieldListStatus = null;
    },
    getAllFieldTypeData: (state, action) => {
      state.allFieldTypeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getCodeData: (state, action) => {
      const uniqueArr = new Set([...state.joinFieldCodeData, action.payload?.response]);
      state.joinFieldCodeData = Array.from(uniqueArr);
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.fieldListStatus = null;
    },
    setFieldListData: (state, action) => {
      state.fieldListData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addRecordFormatStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    setGlobalFieldListPrintData: (state, action) => {
      state.isLoading = false;
      state.GlobalFieldListPrintStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },

    setFieldListUsage: (state, action) => {
      state.fieldListDataUsage = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.fieldListUsageStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },

    resetFieldListUsagedata: (state) => {
      state.fieldListDataUsage = {};
      state.isLoading = false;
      state.errorMsg = null;
      state.fieldListUsageStatus = null;
    },

    setJoinCode: (state, action) => {
      state.joinFieldCodeData = action.payload;
    },
    resettingData: (state, action) => {
      state.baseCategoryData = [];
      state.joinFieldCodeData = [];
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
      state.fieldListStatus = null;
      state.fieldListData = {};
      state.fieldListPostStatus = null;
    },
    resetFieldListData: (state, action) => {
      state.fieldListData = {};
    },
    resetLinkedCatagories: (state, action) => {
      state.linkedCategoriesData = [];
    },
    resettingGroupData: (state, action) => {
      state.groupData = [];
    },
    resetNoteMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.systemNotesStatus = null;
      state.isSystemNoteLoading = false;
      state.notesuccessMsg = null;
    },
    resetGlobalFieldStatus: (state, action) => {
      state.addGlobalFieldListStatus = null;
      state.addSuccessMsg = null;
    },
    resetStatus: (state) => {
      state.fieldListStatus = null;
      state.addGlobalFieldListStatus = null;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetDefault: (state, action) => {
      state.defaultCode = null;
      state.defaultMessage = null;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.fieldListStatus = null;
      state.fieldListData = {};
      state.fieldListPostStatus = null;
      state.GlobalFieldListPrintStatus = null;
    },
    fetchAddSuccess: (state, action) => {
      state.addSuccessMsg = action.payload.message;
      state.isLoading = false;
    },
    resetCode: (state, action) => {
      state.joinFieldCodeData = state.joinFieldCodeData.filter((item) => item !== action.payload);
    },
    postFieldListData: (state, action) => {
      state.fieldListStatus = action.payload.status;
      state.fieldListPostStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.message;
    },
    postFieldListDefaultData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.defaultCode = action.payload.response;
      state.defaultMessage = action.payload.message;
    },
    getAllCodeAndDescription: (state, action) => {
      state.allCodeAndDescription = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetGlobalFieldListData: (state, action) => {
      state.globalFieldListData = {};
    },
    resetDownloadMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.DataRepoPrintStatus = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    setConfigUrl: (state, action) => {
      state.isLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state, action) => {
      state.configurationUrl = '';
    },
    resetDockey: (state, action) => {
      state.dockey = '';
    },
    setDockey: (state, action) => {
      state.isLoading = false;
      state.dockey = action.payload;
    },
  },
});

export default slice.reducer;

export const {
  fetchStart,
  fetchError,
  fetchSuccess,
  resetMsg,
  resetStatus,
  postGroupData,
  postGlobalFieldAddData,
  resetGlobalFieldStatus,
  postFieldListData,
  postFieldListDefaultData,
  getCodeData,
  fetchAddSuccess,
  resettingData,
  resetCode,
  getBaseCategoryData,
  getFieldTypeData,
  getAllFieldTypeData,
  setFieldListData,
  resetNoteMessage,
  setJoinCode,
  setGlobalFieldListPrintData,
  setFieldListUsage,
  resetFieldListUsagedata,
  postSystemNotesData,
  fetchNoteStart,
  resettingGroupData,
  getAllCodeAndDescription,
  resetFieldListData,
  getGlobalFieldListData,
  resetGlobalFieldListData,
  getLinkedCategoriesData,
  resetLinkedCatagories,
  resetDownloadMessage,
  fetchDropDownData,
  resetDefault,
  setConfigUrl,
  resetConfigUrl,
  setDockey,
  resetDockey,
} = slice.actions;

export const getBaseCategory = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lookup/find/all/lookup`, {
      typeCode: [CATEGORY],
    })
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          const categoryData =
            data?.data?.CATEGORY?.length > 0 ?
              data?.data?.CATEGORY?.map((el) => {
                return {
                  categoryCode: el?.valueCode,
                  categoryName: el?.value,
                };
              }) :
              [];
          dispatch(getBaseCategoryData(categoryData));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getLinkedCategories = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${GLOBAL_FIELD}/get/categoryrelation`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getLinkedCategoriesData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getFieldType = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-repository/find/all/fieldType`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getFieldTypeData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getAllFieldType = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/get/all/fieldtypes`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getAllFieldTypeData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchGroupData = (baseValue) => {
  return (dispatch) => {
    httpPost(`${GLOBAL_FIELD}/find/groupcode/listofcategory`, {
      category: [baseValue],
    })
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postGroupData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getCode = (fieldCodeValue, callBack) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${GLOBAL_FIELD}/find/globalfield/category/${fieldCodeValue}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          callBack(data.response);
          dispatch(getCodeData(data));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchFieldListData = (fieldListId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`globalfield/find/fieldlist/${fieldListId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(setFieldListData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchGlobalFieldListData = (fieldListId, AuditFieldList) => {
  const url = AuditFieldList ?
    `globalfield/find/fieldlist/${fieldListId}/AuditField` :
    `globalfield/find/fieldlist/${fieldListId}/Global`;
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(url)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getGlobalFieldListData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const printGlobalFieldList = (data, AuditFieldList) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`globalfield/print/fieldlist`, data)
      .then((data) => {
        if (data && data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postPrintGlobalFieldList({dockey: data?.message}, data, AuditFieldList));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const fetchFieldListUsage = (fieldListCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/usage/formularulegroup/${fieldListCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(setFieldListUsage(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchGlobalFieldListUsage = (fieldListCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`globalfield/get/fieldlistusage/${fieldListCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(setFieldListUsage(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postPrintGlobalFieldList = (payload, postRuleGroupData, AuditFieldList) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`globalfield/generateurlprintglobalfieldlist`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(
          //   setGlobalFieldListPrintData({
          //     ...postRuleGroupData,
          //     response: AuditFieldList
          //       ? "Audit Field List Downloaded Successfully"
          //       : "Field List Downloaded Successfully",
          //   })
          // );
          // download(data.data);
          dispatch(fetchDownloadSuccess(postRuleGroupData));
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(fetchDownloadSuccess(postRuleGroupData));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const postSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNoteStart());
    httpPost(`globalfield/save/fieldlistnotes`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getDataCalculationData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('lookup/find/all/lookup', {
      typeCode: [RETURN_TYPE],
    })
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchDropDownData(data.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const ResetAddGlobalFieldList = () => {
  return (dispatch) => {
    dispatch(resetGlobalFieldStatus());
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};

export const resetData = () => {
  return (dispatch) => {
    dispatch(resettingData());
  };
};
export const resetFieldsData = () => {
  return (dispatch) => {
    dispatch(resetFieldListData());
  };
};
export const resetGroupData = () => {
  return (dispatch) => {
    dispatch(resettingGroupData());
  };
};
export const resetUsageData = () => {
  return (dispatch) => {
    dispatch(resetFieldListUsagedata());
  };
};
export const resetAddFieldListStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetNoteMessage());
  };
};
export const removeCode = (category) => {
  return (dispatch) => {
    dispatch(resetCode(category));
  };
};
export const resetGlobalFieldList = () => {
  return (dispatch) => {
    dispatch(resetGlobalFieldListData());
  };
};
export const SetJoinCode = (code) => {
  return (dispatch) => {
    dispatch(setJoinCode(code));
  };
};
export const resetLinkedCatagoriesData = () => {
  return (dispatch) => {
    dispatch(resetLinkedCatagories());
  };
};
export const resetDownload = () => {
  return (dispatch) => {
    dispatch(resetDownloadMessage());
  };
};
export const resetDefaultData = () => {
  return (dispatch) => {
    dispatch(resetDefault());
  };
};

export const postFieldList = (details, AuditFieldList) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${GLOBAL_FIELD}/save/fieldlist`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 500) {
          dispatch(fetchError(data?.data?.error));
        } else if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data?.status && data?.status === 200 && data?.response?.userMetrix) {
          dispatch(postGlobalFieldAddData(data));
          dispatch(fetchAddSuccess(data));
        } else if (data && data?.status && data?.status === 200 && data?.message === 'Yes') {
          dispatch(postFieldListDefaultData(data));
        } else if (data && data?.status && data?.status === 200) {
          const values = {
            ...data,
            message: AuditFieldList ?
              'Audit Field List added/modified Successfully' :
              'Field List added/modified Successfully',
          };
          dispatch(postFieldListData(values));
          dispatch(fetchSuccess(values));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const getForeignKeyFieldData = (payload, dataCallBack) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`globalfield/search/all/listofcategory`, payload)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dataCallBack(data.response.resultObject[0]);
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAllCodeAndDescription = (data) => {
  return (dispatch) => {
    httpGet(`globalfield/find/all/fieldlistcodeanddescription`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllCodeAndDescription(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
